<template>
  <div class="DataUpdate">
    <modal
      name="ProgramModal"
      width="80%"
      height="auto"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
    >
      <div class="tabcontent">
        <ValidationObserver ref="obsFieldsUpdate">
          <FormupdatePeriods
            :FieldsForm="formUpdate"
            :ModelForm="formUpdModel"
            :method="executeProcess"
            v-if="renderComponent2"
          />
        </ValidationObserver>
        <div class="modalActions">
          <button
            v-if="!isNew"
            id="updatePeriod"
            class="loginbtn primaryBtn"
            @click="updatePeriod"
          >
            Actualizar
          </button>

          <button
            v-else
            id="AddProgram"
            class="loginbtn primaryBtn"
            @click="AddProgram"
          >
            Guardar
          </button>

          <button
            id="CancelUser"
            class="loginbtn secondaryBtn"
            @click="CancelUser"
          >
            Cancelar
          </button>
        </div>
      </div>
    </modal>
    <div class="titlePage">Administración - Programas Plan Ibero</div>
    <va-notification color="info" v-if="addRExito" class="refNoData">Se creo correctamente el programa plan solicitado.</va-notification>
    <va-notification color="info" v-if="UpdRExito" class="refNoData">Se actualizo correctamente el programa plan solicitado.</va-notification>
    <va-notification color="danger" v-if="refNoUpdate" class="refNoData">La actualizacion del programa plan presento un fallo.</va-notification>
    <va-notification color="danger" v-if="refWSUpdate" class="refNoData">El servicio que ejecuta la actualización no se encuentra activo.</va-notification>

    <ValidationObserver ref="obsFieldsSearch">
      <FormSearchProgram
        :FieldsForm="formSearch"
        :ModelForm="formSchModel"
        :method="executeProcess"
      />
    </ValidationObserver>
    <va-notification
      color="danger"
      id="refNoData"
      class="refNoData noShow"
    >No se encontró información del programa solicitado.</va-notification>
    <div class="listPrograms">
      <DataTablePrograms
        :InfoView="this.DLPrograms"
        :HeadTable="this.HDProgram"
        :method="processData"
        v-if="renderComponent1"
      />
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line import/no-duplicates
import FormSearchProgram from '@/components/forms/Forms.vue'
// eslint-disable-next-line import/no-duplicates
import FormupdatePeriods from '@/components/forms/Forms.vue'
import IberoHelpers from '@/store/helpers.js'
import DataTablePrograms from '@/components/data-tables/DataProPlan.vue'

export default {
  name: 'DataUpdate',
  components: {
    DataTablePrograms,
    FormSearchProgram,
    FormupdatePeriods,
  },
  data () {
    return {

      DegreeList: IberoHelpers.getDegrees(this.$store),
      PlanList: IberoHelpers.getPlan(this.$store),
      ProgramList: IberoHelpers.getPrograms2(this.$store),
      formSchModel: {},
      formSearch: [
        {
          id: 'Sch_Button',
          type: 'button',
          placeholder: 'Consultar Programa Plan',
          class: 'col-md-3',
        },
        {
          id: 'Sch_ButtonNew',
          type: 'button',
          placeholder: 'Crear Programa Plan',
          class: 'col-md-3',
        },
      ],
      formUpdModel: {
        idProgram: '',
        idPlan: '',
        staActive: '',        
      },

      formUpdate: [
        {
          id: 'idProgram',
          model: 'idProgram',
          name: 'Programa',
          type: 'Select',
          placeholder: 'Selecciona un Programa',
          class: 'col-md-4',
          values: this.$store.state.ProgramList,
          validate: {
            required: true,
          },
        },
        {
          id: 'idPlan',
          model: 'idPlan',
          name: 'Plan',
          type: 'Select',
          placeholder: 'Selecciona un Plan',
          class: 'col-md-4',
          values: this.$store.state.PlanList,
          validate: {
            required: true,
          },
        },
        {
          id: 'staActive',
          model: 'staActive',
          name: 'Estado',
          type: 'Select',
          placeholder: 'Seleccionar...',
          class: 'col-md-4',
          values: [
            { id: 1, value: 'Activo' },
            { id: 0, value: 'Inactivo' },
          ],
          validate: {
            required: true,
          },
        },
      ],

      HDProgram: [

        {
          name: 'idProgramPlan',
          title: 'Id Programa Plan',
          sortField: 'idProgramPlan',
          width: '20%',
        },
        {
          name: 'idProgram',
          title: 'id Programa',
          sortField: 'idProgram',
          width: '10%',
        },
        {
          name: 'namProgram',
          title: 'Program',
          sortField: 'namProgram',
          width: '50%',
        },
        {
          name: 'idPlan',
          title: 'id Plan',
          sortField: 'idPlan',
          width: '10%',
        },
        {
          name: 'namPlan',
          title: 'Plan',
          sortField: 'namPlan',
          width: '20%',
        },
        {
          name: '__slot:staActive',
          title: 'Activo',
          dataClass: 'text-center',
          width: '10%',
        },
        {
          name: '__slot:actions',
          dataClass: 'text-right',
          actionRef: [
            {
              label: 'Editar',
              icon: 'fa-pencil',
              action: 'edit',
            },
          ],
        },
      ],
      DLPrograms: [],
      renderComponent1: false,
      renderComponent2: false,
      addRExito: false,
      UpdRExito: false,
      refNoUpdate: false,
      refWSUpdate: false,
      isNew: false,
    }
  },
  methods: {
    executeProcess: function (event, refer) {
      this.limpiaref()
      switch (event.target.id) {
        case 'btn_Sch_Button':
          debugger
          this.isNew = false
          return new Promise((resolve, reject) => {
            this.$refs.obsFieldsSearch.validate().then(results => {
              if (!results) {
                resolve(false)
              } else {
                this.searchForm()
                resolve(true)
              }
            })
          })
        case 'btn_Sch_ButtonNew':
          this.limpiaref()
          this.clearFields()
          this.isNew = true
          IberoHelpers.forceRerender2(this)
          this.$modal.show('ProgramModal')
      }
      this.$refs.obsFieldsSearch.validate()
    },
    searchForm () {
      debugger
      document.getElementById('refNoData').classList.add('noShow')

      this.isNew = false
      let loader = this.$loading.show()
      var ListPeriods = IberoHelpers.getProgramPlan(this.$store, this.formSchModel, 0)
      this.renderComponent1 = false
      ListPeriods.then(Response => {
        debugger
        if ((Response.data === undefined) || (Response.data === '')) {
          document.getElementById('refNoData').classList.remove('noShow')
        } else {
          if (Array.isArray(Response.data)) {
            this.DLPrograms = Response.data
          } else {
            this.DLPrograms = [Response.data]
          }
          IberoHelpers.forceRerender1(this)
        }
        loader.hide()
      })
    },
    updatePeriod () {
      debugger
      this.limpiaref()
      return new Promise((resolve, reject) => {
        this.$refs.obsFieldsUpdate.validate().then(results => {
          if (!results) {
            resolve(false)
          } else {
            let loader = this.$loading.show()
            debugger
            var totalinf = IberoHelpers.updateProgramaPlan(this.$store, this.formUpdModel)
            totalinf.then(Response => {
              this.renderComponent1 = false
              if (Response === false) {
                this.refWSUpdate = true
                resolve(false)
              } else if (!(Response.status === 200)) {
                this.refNoUpdate = true
                resolve(false)
              } else {
                this.UpdRExito = true
                resolve(true)
              }
              this.$modal.hide('ProgramModal')
              this.searchForm()
              loader.hide()
            })
          }
        })
      })
    },
    AddProgram () {
      debugger
      this.limpiaref()
      return new Promise((resolve, reject) => {
        this.$refs.obsFieldsUpdate.validate().then(results => {
          if (!results) {
            resolve(false)
          } else {
            let loader = this.$loading.show()
            debugger 
            var totalinf = IberoHelpers.addProgramaPlan(this.$store, this.formUpdModel)
            debugger
            totalinf.then(Response => {
              debugger
              this.renderComponent1 = false
              if (Response === false) {
                this.refWSUpdate = true
                resolve(false)
              } else if (!(Response.status === 200)) {
                this.refNoUpdate = true
                resolve(false)
              } else {
                this.addRExito = true
                resolve(true)
              }
              this.$modal.hide('ProgramModal')
              this.searchForm()
              loader.hide()
            })
          }
        })
      })
    },
    CancelUser () {
      this.limpiaref()
      this.clearFields()
      this.$modal.hide('ProgramModal')
    },

    limpiaref () {
      this.addRExito = false
      this.UpdRExito = false
      this.refNoUpdate = false
      this.refWSUpdate = false
      document.getElementById('refNoData').classList.add('noShow')
    },
    clearFields () {
      this.formUpdModel.idProgram = ''
      this.formUpdModel.idPlan = ''
      this.formUpdModel.staActive = ''
    },
    processData: function (dataInf, refdata) {
      this.limpiaref()
      this.isNew = false
      this.formUpdModel.idProgram = dataInf.idProgram
      this.formUpdModel.idPlan = dataInf.idPlan
      this.formUpdModel.staActive = dataInf.staActive

      IberoHelpers.forceRerender2(this)
      this.$modal.show('ProgramModal')
    },
  },
}
</script>